__turbopack_context__.v({
  "className": "ibm_plex_mono_1c5ad7a5-module__8sByHG__className",
});
